import type React from 'react'

const FileIconImage: React.FC = () => {
  return (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.0625 4.875V0.625H2.21875C1.32227 0.625 0.625 1.35547 0.625 2.21875V16.0312C0.625 16.9277 1.32227 17.625 2.21875 17.625H11.7812C12.6445 17.625 13.375 16.9277 13.375 16.0312V5.9375H9.125C8.52734 5.9375 8.0625 5.47266 8.0625 4.875ZM3.8125 8.0625C4.37695 8.0625 4.875 8.56055 4.875 9.125C4.875 9.72266 4.37695 10.1875 3.8125 10.1875C3.21484 10.1875 2.75 9.72266 2.75 9.125C2.75 8.56055 3.21484 8.0625 3.8125 8.0625ZM11.1836 15.2344C11.084 15.4004 10.8848 15.5 10.7188 15.5H3.28125C3.08203 15.5 2.88281 15.4004 2.7832 15.2344C2.7168 15.0684 2.7168 14.8691 2.81641 14.7031L4.60938 12.0469C4.67578 11.8809 4.8418 11.7812 5.04102 11.7812C5.24023 11.7812 5.37305 11.8809 5.47266 12.0469L5.9375 12.7109L7.43164 10.4531C7.53125 10.2871 7.69727 10.1875 7.86328 10.1875C8.0625 10.1875 8.22852 10.2871 8.32812 10.4531L11.1504 14.7031C11.25 14.8359 11.25 15.0684 11.1836 15.2344ZM9.125 0.625V4.875H13.375L9.125 0.625Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default FileIconImage
